export const formatPrice = (value, maxDigits = 2) => {
    const toLocaleStringOptions = {
        minimumFractionDigits: maxDigits,
        maximumFractionDigits: maxDigits
    };

    const numericValue = Number(value);

    const price = Math.abs(numericValue).toLocaleString('en-US', toLocaleStringOptions).replace(/,$/, '.');

    if (isNaN(numericValue)) {
        return value;
    }

    if (numericValue < 0) {
        return `-$${price}`;
    }

    return `$${price}`;
};
